module.exports = __webpack_public_path__ + "static/OpenWeather-Logo-7138ec88c3c800d44154c249c8d8cda2.jpg";